import * as React from "react";
const SvgFiRrBadgerHoney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m22.072 2.829-1.721-.573c-2.364-.79-4.925.192-6.365 2.445-.626.978-2.087 1.326-3.238 1.326L7.5 6H7C4.047 6 .594 8.05.012 11.849A1 1 0 0 0 1 13h.559l1.15 6.533A2.98 2.98 0 0 0 5.647 22c.893 0 1.73-.394 2.299-1.082a2.98 2.98 0 0 0 .632-2.462L8.548 18h3.451v1.017C12 20.663 13.337 22 15.017 22A2.986 2.986 0 0 0 18 19.018v-.3c0-1.813.2-4.436 1.151-6.632a6.25 6.25 0 0 1 2.697-2.968 4.18 4.18 0 0 0 2.15-3.572 2.8 2.8 0 0 0-1.928-2.714zm-7.224 3.878-1.789 2.39A5.27 5.27 0 0 1 9 11H3.753a4.8 4.8 0 0 1 .919-1.646C5.425 8.48 6.429 8 7.492 8l3.249.027c1.65 0 3.106-.48 4.107-1.32m6.031.659a8.26 8.26 0 0 0-3.564 3.923C16.228 13.799 16 16.715 16 18.718v.299c0 .542-.44.983-1.017.983a.984.984 0 0 1-.982-.983V18c0-1.103-.898-2-2-2H8.548c-.621 0-1.201.277-1.592.759a2.03 2.03 0 0 0-.415 1.693l.072.379a.97.97 0 0 1-.208.812.97.97 0 0 1-.758.356.98.98 0 0 1-.97-.813L3.59 12.999h5.409c2.169 0 4.208-.956 5.63-2.663l3.178-4.248c.715-.98 1.068-1.086 4.018-1.09a.8.8 0 0 1 .172.508 2.18 2.18 0 0 1-1.117 1.859"
    />
  </svg>
);
export default SvgFiRrBadgerHoney;
